export default {
  state: {
    activity: {},
    editingActivityByUuid: {},
  },

  /**
   * getter method
   */
  getCurrentPageNo(uuid) {
    return this.state.activity[uuid]?.currentPage ?? 1;
  },
  isLoading(uuid) {
    return this.state.activity[uuid].loading;
  },

  /**
   * mutation method
   */
  setCurrentPageNo(uuid, currentPage) {
    const state = this.state.activity[uuid];
    currentPage = parseInt(currentPage);
    this.state.activity[uuid] = {
      ...state,
      currentPage: currentPage,
    };
  },
  setLoadingState(uuid, loading) {
    const state = this.state.activity[uuid];
    this.state.activity[uuid] = {
      ...state,
      loading: loading,
    };
  },
  addEditingQuiz(payload) {
    this.state.editingActivityByUuid[payload.uuid] = payload;
  },
};
